import { useState, useContext } from "react";

import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Button,
  HStack,
  Tag,
  TagLabel,
  TagCloseButton,
  IconButton,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { UserProfileContext } from "../../../context/UserContext";
import { validateCoupon } from "../services/couponService";

export const StepOrderForm = ({
  nextStep,
  userProfile,
  amountPaid,
  setAmountPaid,
  unit,
  setUnit,
  unitPurchased,
  amountCal,
  commodityType,
  appliedCoupons,
  setAppliedCoupons,
  meterId,
  quote,
  quoteLoading,
  quoteError,
}) => {
  const [couponInput, setCouponInput] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);

  const pageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor,
  );

  const displayData = useSelector(
    (state) => state?.switchTab?.currentDisplay?.dashboard?.rate,
  );

  // For this flow we only support water — use commodityType to force water labels
  const isWater =
    (commodityType || "").toLowerCase() === "water" ||
    displayData?.unit === "/Liter";

  console.log("displayData", isWater, userProfile, commodityType, displayData);

  const handleAmount = (e) => {
    setAmountPaid(e.target.value);
    setUnit("");
  };

  const hadleUnit = (e) => {
    setUnit(e.target.value);
    setAmountPaid("");
  };

  const formatNumber = (val) => {
    if (val === null || val === undefined || val === "") return "";
    const raw = String(val).toString().replace(/,/g, "");
    const num = Number(raw);
    if (Number.isNaN(num)) return "";
    return num.toLocaleString();
  };

  const handleUnitFormatted = (e) => {
    const input = e.target.value || "";
    const cleaned = input.replace(/,/g, "");
    if (cleaned === "") {
      setUnit("");
      setAmountPaid("");
      return;
    }
    const match = cleaned.match(/^\d*(?:\.\d*)?/);
    const numeric = match ? match[0] : "";
    setUnit(numeric);
    setAmountPaid("");
  };

  const handleAmountFormatted = (e) => {
    const input = e.target.value || "";
    const cleaned = input.replace(/,/g, "");
    if (cleaned === "") {
      setAmountPaid("");
      setUnit("");
      return;
    }
    const match = cleaned.match(/^\d*(?:\.\d*)?/);
    const numeric = match ? match[0] : "";
    setAmountPaid(numeric);
    setUnit("");
  };

  const { activeAccount } = useContext(UserProfileContext) || {};

  const estateId =
    activeAccount?.estateId ||
    (Array.isArray(userProfile?.estates) &&
      userProfile?.estates?.[0]?.estateId) ||
    null;

  // meterId is already fully resolved by the parent (Steps.jsx):
  // Redux dashboardData → context activeAccount.meterNumbers → houseId fallback
  const resolvedMeterNumber = meterId;

  const handleApplyCoupon = async () => {
    const code = couponInput.trim().toUpperCase();
    if (!code || !commodityType || !estateId) return;
    if (appliedCoupons.find((c) => c.code === code)) return; // already applied

    const result = await validateCoupon(
      code,
      commodityType,
      estateId,
      setCouponLoading,
    );
    if (result) {
      setAppliedCoupons((prev) => [
        ...prev,
        {
          code: result.code,
          valueInNaira: result.valueInNaira,
          valueInKobo: result.valueInKobo,
        },
      ]);
      setCouponInput("");
    }
  };

  const handleRemoveCoupon = (code) => {
    setAppliedCoupons((prev) => prev.filter((c) => c.code !== code));
  };

  // Checkpoint 2C — the discount/total shown here comes from the server
  // quote (against the full gross amount, including the service fee), not
  // a local sum against the utility subtotal alone. That local-only
  // calculation was the exact source of OVEND-FIX-07: it could show "FREE"
  // merely because a coupon covered the utility subtotal, while the
  // service fee portion was still unpaid.
  const couponTotalNaira = quote?.couponDiscountApplied ?? 0;
  const netAmount = quote?.payableAmount;
  const fullyCovered = !!quote?.fullyCoveredByCoupon;

  //const amountPaid = unitPurchased * 250

  // const handleSubmit = () => {
  //   const payload = {
  //     amountPaid,
  //     unitPurchased,
  //     meterId,
  //     commodityType: utilityType,
  //   }

  // }

  return (
    <Box width="100%" p={["", "", "50px 30px"]}>
      <Flex
        direction={["column", "column", "row"]}
        bg="#F9FEFF"
        width="100%"
        justifyContent="space-between"
        px={["10px", "10px", "30px"]}
        fontSize={["14px", "14px", "16px"]}
      >
        <Flex
          direction="column"
          width={["100%", "100%", "50%"]}
          color="#050509"
          py={["30px", "30px", "50px"]}
        >
          <Flex width={["100%", "100%"]} justifyContent="space-between">
            <Text width="40%">Name</Text>
            <Text width="60%" className="user-info_name">
              {userProfile?.name}
            </Text>
          </Flex>
          {/* <Flex my="15px" width="100%" justifyContent="space-between">
            <Text width="40%">Estate Name</Text>
            <Text width="60%" className="user-info_name">
              {userProfile?.houseId?.houseNumber}
            </Text>
          </Flex> */}
          <Flex width="100%" justifyContent="space-between">
            <Text width="40%">Phone number</Text>
            <Text width="60%" className="user-info_name">
              {userProfile?.phoneNumber}
            </Text>
          </Flex>
          {/* <Flex justifyContent="space-between" my="15px" width="100%">
            <Text width="40%">Meter type</Text>
            <Text width="60%" className="user-info_name">
              Prepaid
            </Text>
          </Flex> */}
          <Flex width="100%" justifyContent="space-between">
            <Text width="40%">Meter Number</Text>
            <Text width="60%" className="user-info_name">
              {resolvedMeterNumber}
            </Text>
          </Flex>
        </Flex>
        <Tabs
          width={["100%", "100%", "50%"]}
          p="50px 30px"
          borderLeft={["none", "none", "1px solid #d4d4d4"]}
          borderTop={["1px solid #d4d4d4", "1px solid #d4d4d4", "none"]}
        >
          <TabList my="-20px" mb="5px">
            <Tab
              _selected={{
                color: pageColor,
                bg: "none",
                borderBottom: `4px solid ${pageColor}`,
                boxShadow: "none",
                outline: "none !important",
              }}
            >
              Amount
            </Tab>
            <Tab
              _selected={{
                color: pageColor,
                bg: "none",
                borderBottom: `4px solid ${pageColor}`,
                boxShadow: "none",
                outline: "none !important",
              }}
            >
              {isWater ? "Litre" : displayData?.unit === "/kg" ? "KG" : "Token"}
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <Text>
                How much{" "}
                {isWater
                  ? "Water"
                  : displayData?.unit === "/kg"
                    ? "Gas"
                    : "Token"}{" "}
                Do you want to buy?
              </Text>
              <FormControl my="15px">
                <FormLabel htmlFor="amount" color={pageColor}>
                  Enter amount
                </FormLabel>
                <Input
                  id="amount"
                  type="text"
                  color={"#264653"}
                  value={formatNumber(amountPaid)}
                  onChange={handleAmountFormatted}
                />
              </FormControl>
              <FormControl my="15px">
                <FormLabel htmlFor="unit" color={pageColor}>
                  {isWater
                    ? "litre"
                    : displayData?.unit === "/kg"
                      ? "KG"
                      : "Token"}
                </FormLabel>
                <Input
                  id="unit"
                  type="text"
                  color={"#264653"}
                  value={
                    unitPurchased ? formatNumber(unitPurchased.toFixed(2)) : ""
                  }
                  isDisabled
                />
              </FormControl>
            </TabPanel>
            <TabPanel>
              <Text>
                How much{" "}
                {isWater
                  ? "Water"
                  : displayData?.unit === "/kg"
                    ? "Gas"
                    : "Token"}{" "}
                do you want to buy?
              </Text>
              <FormControl my="15px">
                <FormLabel htmlFor="unit" color={pageColor}>
                  {isWater
                    ? "Litre"
                    : displayData?.unit === "/kg"
                      ? "KG"
                      : "Token"}
                </FormLabel>
                <Input
                  id="unit"
                  type="text"
                  color={"primary"}
                  value={formatNumber(unit)}
                  onChange={handleUnitFormatted}
                />
              </FormControl>
              <FormControl my="15px">
                <FormLabel htmlFor="amount" color={pageColor}>
                  Enter amount
                </FormLabel>
                <Input
                  id="amount"
                  type="text"
                  value={amountCal ? formatNumber(amountCal) : ""}
                  color={"#264653"}
                  isDisabled
                />
              </FormControl>
            </TabPanel>
          </TabPanels>
          <Box px="15px">
            {/* Coupon section */}
            <Box
              mb="15px"
              p="12px"
              bg="#f7feff"
              borderRadius="8px"
              border="1px solid #d4eef0"
            >
              <Text
                fontSize="13px"
                fontWeight="semibold"
                color="#264653"
                mb="8px"
              >
                Have a coupon code?
              </Text>
              <HStack>
                <Input
                  size="sm"
                  placeholder="Enter code e.g. WATER-MAR26-A3X7"
                  value={couponInput}
                  onChange={(e) => setCouponInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleApplyCoupon()}
                  textTransform="uppercase"
                />
                <Button
                  size="sm"
                  bg={pageColor}
                  color="#fff"
                  _hover={{ bg: pageColor }}
                  isLoading={couponLoading}
                  onClick={handleApplyCoupon}
                  isDisabled={!couponInput.trim()}
                  minW="70px"
                >
                  Apply
                </Button>
              </HStack>

              {appliedCoupons.length > 0 && (
                <Box mt="10px">
                  <HStack wrap="wrap" spacing={2}>
                    {appliedCoupons.map((c) => (
                      <Tag
                        key={c.code}
                        size="sm"
                        colorScheme="teal"
                        borderRadius="full"
                      >
                        <TagLabel>
                          {c.code} (₦{c.valueInNaira.toLocaleString()})
                        </TagLabel>
                        <TagCloseButton
                          onClick={() => handleRemoveCoupon(c.code)}
                        />
                      </Tag>
                    ))}
                  </HStack>

                  {quoteLoading && (
                    <Text fontSize="13px" color="gray.500" mt="8px">
                      Calculating your discount…
                    </Text>
                  )}
                  {quoteError && (
                    <Text fontSize="13px" color="red.500" mt="8px">
                      {quoteError}
                    </Text>
                  )}
                  {!quoteLoading && !quoteError && quote && (
                    <>
                      {/* Checkpoint 2C: this discount and total are the
                          server-authoritative quote, applied against the
                          gross amount (utility + service fee) — never
                          against the utility subtotal alone. The exact same
                          figures are shown again on the Review & Payment
                          step, so the total here never disappears or
                          changes at checkout. */}
                      <Flex justify="space-between" mt="8px" fontSize="13px">
                        <Text color="#666">Coupon discount:</Text>
                        <Text color="#2A9D8F" fontWeight="semibold">
                          - ₦{couponTotalNaira.toLocaleString()}
                        </Text>
                      </Flex>
                      <Flex justify="space-between" fontSize="13px">
                        <Text color="#666">You pay:</Text>
                        <Text
                          fontWeight="bold"
                          color={fullyCovered ? "#2A9D8F" : "#264653"}
                        >
                          {fullyCovered
                            ? "Fully covered by coupon"
                            : `₦${netAmount?.toLocaleString()}`}
                        </Text>
                      </Flex>
                    </>
                  )}
                </Box>
              )}
            </Box>

            <Button
              width="100%"
              bg={pageColor}
              color="#fff"
              px="20px"
              _hover={{ bg: pageColor }}
              onClick={nextStep}
              // onClick={handleSubmit}
            >
              Continue to payment
            </Button>
          </Box>
        </Tabs>
      </Flex>
    </Box>
  );
};
